/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Scheduled_AtInputs */

const en_coaching_scheduled_at = /** @type {(inputs: Coaching_Scheduled_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled`)
};

const id_coaching_scheduled_at = /** @type {(inputs: Coaching_Scheduled_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal`)
};

/**
* | output |
* | --- |
* | "Scheduled" |
*
* @param {Coaching_Scheduled_AtInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_scheduled_at = /** @type {((inputs?: Coaching_Scheduled_AtInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Scheduled_AtInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_scheduled_at(inputs)
	return en_coaching_scheduled_at(inputs)
});